import {request} from '@/helpers/apiClient'
import {PROMOTION_TYPES_CONFIG} from '@/utils/constants/apiConfig/promotionTypesConfig'

export const getPromotionTypes = () => request(PROMOTION_TYPES_CONFIG.PROMOTION_TYPES)

export const getPromotionConfig = () => request(PROMOTION_TYPES_CONFIG.GET_PROMOTION_CONFIG)

export const updatePromotionConfig = body => {
  return request(PROMOTION_TYPES_CONFIG.UPDATE_PROMOTION_CONFIG, {
    data: body,
  })
}

export const createPromotion = promotionData => {
  return request(PROMOTION_TYPES_CONFIG.CREATE_PROMOTION, {
    data: promotionData,
  })
}

export const updatePromotion = (promotionId, promotionData) => {
  return request(PROMOTION_TYPES_CONFIG.UPDATE_PROMOTION(promotionId), {data: promotionData})
}

export const uploadPromotionMedia = (promotionId, formData) =>
  request(PROMOTION_TYPES_CONFIG.UPLOAD_PROMOTION_MEDIA(promotionId), {formData})

export const processPromotionFile = promotionId => request(PROMOTION_TYPES_CONFIG.PROCESS_PROMOTION_FILE(promotionId))

export const updatePromotionStatus = (promotionId, status) => request(PROMOTION_TYPES_CONFIG.UPDATE_PROMOTION_STATUS(promotionId, status))
